module.exports = __webpack_public_path__ + "img/ennetix-network-elements-page.4f80b5f4.png";